import { createFileRoute, redirect, useRouter } from '@tanstack/react-router'
import { useCallback, useEffect, useRef } from 'react'
import { toast } from 'sonner'
import { LoadingOverlay } from '@mantine/core'
import OneSignal from 'react-onesignal'
import * as Sentry from '@sentry/react'
import useAuthMutation from '@/hooks/useAuthMutation'
import { isHttpError } from '@/utils/http'

export const Route = createFileRoute('/auth/logout')({
  beforeLoad: ({ context }) => {
    if (!context.authContext.accessToken) {
      return redirect({
        to: '/auth/login',
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const hasRun = useRef(false)
  const router = useRouter()
  const { logout, onLogout } = useAuthMutation()

  const handleLogout = useCallback(async () => {
    await new Promise((resolve) => requestAnimationFrame(resolve))
    return logout.mutate(null, {
      onSuccess: async () => {
        if (Sentry.isEnabled()) {
          Sentry.setUser(null)
        }
        if (OneSignal.User.onesignalId && OneSignal.User.externalId) {
          await OneSignal.logout()
        }
        router.invalidate()
      },
      onError: async (error) => {
        if (isHttpError(error)) {
          if (error.response.status === 401) {
            await onLogout()
          }
          router.invalidate()
          toast.success('Successfully logged out.')
        } else {
          toast.error('Something went wrong. Please try again.')
        }
      },
    })
  }, [logout])

  useEffect(() => {
    if (!hasRun.current && !logout.isPending) {
      hasRun.current = true
      handleLogout()
    }
  }, [])

  return (
    <>
      <LoadingOverlay visible={true} zIndex={1000} overlayProps={{ blur: 2 }} />
    </>
  )
}
